import { render, staticRenderFns } from "./ClinicWideAppointmentSetting.vue?vue&type=template&id=18a079ad"
import script from "./ClinicWideAppointmentSetting.vue?vue&type=script&lang=js"
export * from "./ClinicWideAppointmentSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports